import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";
import Dashboard from "@/pages/district/Dashboard";
import SupportHub from "@/pages/district/SupportHub";
import ClubDashboard from "@/pages/ClubDashboard";
import MemberHome from "@/pages/MemberHome";

export default function Home() {
  const { user } = useAuth();
  const [home, setHome] = useState(null);
  const [ctx, setCtx] = useState(undefined); // undefined=unknown, null=none, object=active
  const navigate = useNavigate();
  const isOwner = !!user?.is_platform_owner;

  useEffect(() => {
    (async () => {
      const calls = [api.get("/gov/invitations/pending-check"), api.get("/me/home")];
      if (isOwner) calls.push(api.get("/support/context"));
      const [pc, hr, cx] = await Promise.allSettled(calls);
      if (pc.status === "fulfilled" && pc.value.data?.pending) { navigate("/gov/invitation"); return; }
      setCtx(isOwner ? (cx?.status === "fulfilled" ? (cx.value.data?.context ?? null) : null) : null);
      setHome(hr.status === "fulfilled" ? hr.value.data : { home: "member" });
    })();
  }, [navigate, isOwner]);

  if (!home || ctx === undefined) {
    return (
      <div className="flex items-center gap-2 text-muted-foreground text-sm" data-testid="home-loading">
        <CircleNotch size={18} className="animate-spin text-primary" weight="bold" /> loading…
      </div>
    );
  }
  // Owner with no active support context lands on the Support welcome hub — UNLESS we are
  // in a read-only "View as a role" session, in which case we render the target's real home.
  if (isOwner && !ctx && !home.view_as) return <SupportHub />;
  if (home.home === "district_admin") return <Dashboard />;
  if (home.home === "district_ops") return <Dashboard />;
  if (home.home === "district_official") return <Dashboard />;
  if (home.home === "club") return <ClubDashboard clubId={home.club_id} clubName={home.club_name} clubRole={home.club_role} />;
  return <MemberHome />;
}
